import { EOrder } from 'src/interfaces/Order';
import { ISponsor } from 'src/interfaces/Sponsor';

export type SponsorsPublishedFilter = 'all' | 'true' | 'false';
export type SponsorsSortBy = 'name' | 'sortOrder' | 'createdAt';

type SponsorsFilterOptions = {
  search: string;
  publishedFilter: SponsorsPublishedFilter;
  sortBy: SponsorsSortBy;
  sortOrder: EOrder;
};

export function filterAndSortSponsors(
  sponsors: ISponsor[],
  { search, publishedFilter, sortBy, sortOrder }: SponsorsFilterOptions,
): ISponsor[] {
  const query = search.trim().toLowerCase();

  let result = sponsors.filter(sponsor => {
    if (publishedFilter === 'true' && sponsor.published === false) return false;
    if (publishedFilter === 'false' && sponsor.published !== false) return false;
    if (!query) return true;
    return (
      sponsor.name.toLowerCase().includes(query) ||
      (sponsor.url ?? '').toLowerCase().includes(query)
    );
  });

  result = [...result].sort((a, b) => {
    let cmp = 0;
    switch (sortBy) {
      case 'name':
        cmp = a.name.localeCompare(b.name);
        break;
      case 'sortOrder':
        cmp = (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
        break;
      case 'createdAt':
        cmp =
          new Date(a.createdAt ?? 0).getTime() - new Date(b.createdAt ?? 0).getTime();
        break;
      default:
        break;
    }
    return sortOrder === EOrder.desc ? -cmp : cmp;
  });

  return result;
}
